class ReferenceRange {
  constructor(params) {
    this.title = params.title;
    this.columnNames = [params.firstColumnName, params.secondColumnName, params.thirdColumnName];
    this.rows = params.rows;
  }
}

export { ReferenceRange };
